if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');      
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      // Restore any cart items saved before a Buy It Now redirect.
      this._restoreCartBackup();

      // Buy It Now: intercept dynamic checkout buttons when add-ons are present
      this.bindBuyItNowHandler();
    }

    // ---------- BUY IT NOW (start) ----------
    bindBuyItNowHandler() {
      // Shopify injects dynamic checkout buttons asynchronously, so use a
      // MutationObserver to attach the click handler as soon as they appear.
      const attachListeners = () => {
        const buyItNowButtons = this.querySelectorAll(
          '[data-testid="Checkout-button"], .shopify-payment-button__button, [name="goto_pp"]'
        );
        buyItNowButtons.forEach((btn) => {
          if (!btn.dataset.addonListenerAttached) {
            btn.dataset.addonListenerAttached = 'true';
            btn.addEventListener('click', this.onBuyItNowClick.bind(this), true);
          }
        });
      };

      attachListeners();

      const observer = new MutationObserver(attachListeners);
      observer.observe(this, { childList: true, subtree: true });
    }

    onBuyItNowClick(evt) {
      const addonSelect = this.form.querySelector('#addon-select');

      // No add-on selected — let Shopify handle checkout normally.
      if (!addonSelect || addonSelect.value === '') return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      const mainVariantId = this.form.querySelector('[name="id"]').value;
      const quantityInput = this.querySelector('.quantity__input');
      const quantity      = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      const bundle_id     = Date.now();

      // Carry through any existing line item properties from the form.
      const formData = new FormData(this.form);
      const extraProperties = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          const propName = key.match(/properties\[(.*?)\]/)[1];
          extraProperties[propName] = value;
        }
      }

      // Resolve Dessert value the same way onSubmitHandler does.
      const dessertSelect = this.form.querySelector('#dessert-select');
      const selectedAddonText = addonSelect.options[addonSelect.selectedIndex].text.trim().toLowerCase();
      const dessertValue =
        selectedAddonText === 'dessert' && dessertSelect
          ? dessertSelect.options[dessertSelect.selectedIndex].dataset.title || ''
          : '';

      // Build bundle payload: main item + add-on item.
      let addonVariantId = addonSelect.value;

        if (addonVariantId === "dessert") {

          addonVariantId =
            dessertSelect.value;

        }

        const items = [
          {
            id: mainVariantId,
            quantity: quantity,
            properties: {
              _bundle_id: bundle_id,
              ...extraProperties
            }
          },
          {
            id: addonVariantId,
            quantity: quantity,
            properties: {
              _bundle_id: bundle_id,
              ...(dessertValue ? { Dessert: dessertValue } : {})
            }
          }
        ];

      // Buy It Now with add-on: we need checkout to show only this one bundle,
      // but we must not permanently lose the customer's existing cart items.
      //
      // Flow:
      //  1. Snapshot the current cart.
      //  2. Clear the cart.
      //  3. Add only the Buy It Now bundle.
      //  4. Redirect to /checkout — customer completes purchase here.
      //
      // The saved items are written to sessionStorage before the page unloads.
      // On the next page load (store pages only) _restoreCartBackup() re-adds them.

      fetch('/cart.js')
        .then((r) => r.json())
        .then((currentCart) => {
          // Snapshot existing items so they can be restored after checkout.
          const savedItems = (currentCart.items || []).map((item) => ({
            id: item.variant_id,
            quantity: item.quantity,
            properties: item.properties || {}
          }));
          sessionStorage.setItem('_binCartBackup', JSON.stringify(savedItems));

          // Clear, then add only the Buy It Now bundle.
          return fetch('/cart/clear.js', { method: 'POST' })
            .then(() => fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items })
            }));
        })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            // Add failed — restore the backup immediately and surface the error.
            this._restoreCartBackup();
            this.handleErrorMessage(data.description);
            return;
          }
          window.location.href = window.routes
            ? window.routes.checkout_url || '/checkout'
            : '/checkout';
        })
        .catch((err) => {
          console.error('Buy It Now add-on error:', err);
          this._restoreCartBackup();
        });
    }

    // Restores previously saved cart items from sessionStorage back into the cart.
    // Called automatically on page load if a backup exists (i.e. customer returned
    // from checkout without completing the purchase).
    _restoreCartBackup() {
      const raw = sessionStorage.getItem('_binCartBackup');
      if (!raw) return;
      let savedItems;
      try { savedItems = JSON.parse(raw); } catch (e) { return; }
      if (!savedItems || !savedItems.length) return;
      sessionStorage.removeItem('_binCartBackup');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: savedItems })
      }).catch((e) => console.error('Cart restore error:', e));
    }
    // ---------- BUY IT NOW (end) ----------

  async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var prdQuantityElemnt = new FormData(this.form);   
      const formData = new FormData(this.form);   
        if (!formData.has("quantity") && this.querySelector('.quantity__input')) {
          prdQuantityElemnt = this.querySelector('.quantity__input');
          formData.append("quantity", prdQuantityElemnt.value);
        }

      // Add-ons custom START==================================================
      const addonSelect = this.form.querySelector('#addon-select');

      let selectedAddons = [];

        if (addonSelect && addonSelect.value !== '') {

          if (addonSelect.value === "dessert") {

            const dessertSelect = this.form.querySelector("#dessert-select");

            if (dessertSelect && dessertSelect.value) {

              selectedAddons.push({
                id: dessertSelect.value,
                title: dessertSelect.options[dessertSelect.selectedIndex].dataset.title,
                dessert: true
              });

            }

          } else {

            selectedAddons.push({
              id: addonSelect.value,
              dessert: false
            });

          }

        }

      if(selectedAddons.length > 0){
        const bundle_id = Date.now();
        var mainquantity =   1;
        if (prdQuantityElemnt) {
          mainquantity=prdQuantityElemnt.value;
        }
        const mainid = this.form.querySelector('[name="id"]');
        formData.append(`items[0][properties][_bundle_id]`, bundle_id);
        formData.append(`items[0][id]`, mainid.value);
        formData.append(`items[0][quantity]`, mainquantity);
        formData.delete('id');
        let properties = {};
        for (let [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            const propName = key.match(/properties\[(.*?)\]/)[1];
            properties[propName] = value;
          }
        }

        for (let propName in properties) {
          formData.delete(`properties[${propName}]`);
        }

        for (let propName in properties) {
          formData.append(`items[0][properties][${propName}]`, properties[propName]);
        }

        // Addon items
          let index = 1;

          const dessertSelect = this.form.querySelector('#dessert-select');

          selectedAddons.forEach((addon) => {

            formData.append(`items[${index}][id]`, addon.id);
            formData.append(`items[${index}][quantity]`, mainquantity);
            formData.append(`items[${index}][properties][_bundle_id]`, bundle_id);

            if (addon.dessert) {

              formData.append(
                `items[${index}][properties][Dessert]`,
                addon.title
              );

            }

            index++;

          });

        

      }
      // Add-ons custom END==================================================

      // Duplicate bundle guard START==========================================
      // Shopify always creates a new line item on /cart/add when line item
      // properties differ (each submission stamps a new _bundle_id). This means
      // clicking "Add to Cart" repeatedly with the same product + add-on combo
      // produces duplicate rows for both the main item and the add-on.
      //
      // Strategy: fetch the live cart, check if this exact bundle combo already
      // exists (same main variant + same add-on variant + same Dessert value).
      // If it does, increment both existing lines via /cart/change and skip the
      // /cart/add call entirely by returning early.
      

      const addonSelectGuard = this.form.querySelector('#addon-select');

if (addonSelectGuard && addonSelectGuard.value !== '') {

    const mainVariantIdGuard = parseInt(
        this.form.querySelector('[name="id"]').value,
        10
    );

    const dessertSelectGuard =
    this.form.querySelector('#dessert-select');

let addonVariantId;

if (
    addonSelectGuard.value === "dessert" &&
    dessertSelectGuard
) {

    addonVariantId = parseInt(
        dessertSelectGuard.value,
        10
    );

} else {

    addonVariantId = parseInt(
        addonSelectGuard.value,
        10
    );

}

    const selectedAddonTextGuard =
        addonSelectGuard.options[
            addonSelectGuard.selectedIndex
        ].text.trim().toLowerCase();

    const dessertValueGuard =
        selectedAddonTextGuard === "dessert" && dessertSelectGuard
            ? dessertSelectGuard.options[
                  dessertSelectGuard.selectedIndex
              ].dataset.title || ""
            : "";

        const addQty = prdQuantityElemnt && prdQuantityElemnt.value
          ? parseInt(prdQuantityElemnt.value, 10) : 1;

        const cartResponse = await fetch('/cart.js').then(r => r.json()).catch(() => null);

        if (cartResponse) {
          // Find an existing main-product bundle line: same variant + has _bundle_id.
          
          let existingMainLine = null;
            let existingAddonLine = null;

            for (const mainItem of cartResponse.items) {

                if (mainItem.variant_id !== mainVariantIdGuard) continue;
                if (!mainItem.properties?._bundle_id) continue;

                const bundleId = mainItem.properties._bundle_id;

                const addonItem = cartResponse.items.find((item) => {

                    if (!item.properties?._bundle_id) return false;

                    if (item.properties._bundle_id !== bundleId) return false;

                    if (item.variant_id !== addonVariantId) return false;

                    const itemDessert =
                        item.properties.Dessert || "";

                    return itemDessert === dessertValueGuard;

                });

                if (addonItem) {

                    existingMainLine = mainItem;
                    existingAddonLine = addonItem;
                    break;

                }

            }

          if (existingMainLine && existingAddonLine) {
            // Update existing bundle quantities
            await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    id: existingMainLine.key,
                    quantity: existingMainLine.quantity + addQty
                  })
                });

                await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    id: existingAddonLine.key,
                    quantity: existingAddonLine.quantity + addQty
                  })
                });

            // Refresh page so the cart drawer shows updated data
            window.location.reload();

            return;
          }
          
        }
      }
      // Duplicate bundle guard END============================================

       if (this.cart) {
       
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

      
      config.body = formData;
    

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            if(prdQuantityElemnt){
             document.querySelectorAll('.product-form__input.product-form__quantity [name="quantity"]').forEach(input => {
              input.value = 1;
            });


              const IncValue = 1;
              var priceElement = document.querySelector(".product__info-container");
              var priceElementDIV = document.querySelector(".price-wrapper");
              if (!priceElementDIV) return;
              var currentPrice = priceElement.querySelector(".product-price-current");
              const priceData = currentPrice.dataset.price;
              var SubPrice = priceData.replace(/[^0-9\.]/g, "");
              var ReultPrice = SubPrice.replace(/^(\.+)/g, "");
              var EvalPrice = parseInt(ReultPrice);
              var subtotal = IncValue * EvalPrice;
              var subtotalElement = document.getElementById("subtotal-value");
              if (!subtotalElement) return;
              subtotalElement.innerText = Shopify.formatMoney(
                subtotal + ".00",
                DT_THEME.moneyFormat
              );
              
            }
          }
            console.log(Object.fromEntries(formData.entries()));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');           
        });
    }


    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

$(document).ajaxComplete(function() {
  CartJS.updateCart();
});